import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-9d98158a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "from" }
const _hoisted_2 = { class: "form_left" }
const _hoisted_3 = /*#__PURE__*/_createTextVNode("下载模板")
const _hoisted_4 = { class: "form_right" }
const _hoisted_5 = { class: "dialog-footer" }
const _hoisted_6 = /*#__PURE__*/_createTextVNode("确认修改")

import CTagSelect from '../cTagSelect/cTagSelect.vue'

import { useReflectiveInjector } from '@tanbo/vue-di-plugin';
import { computed, reactive, ref } from 'vue'
import { ContentManageDialogService, DetailData } from './contentManageDialog.service';
import { PayTypes } from '@/services/const.service';
import { ElMessage } from 'element-plus';
import { PayTypeByLabelMap, PayTypeMap } from '@/common/const';
import { OfficePlusStatus } from '../../officeplus.service';
import { downloadByUrlAndName } from '@/common/utils';


export default /*#__PURE__*/_defineComponent({
  props: {
  contentManageDialogVisible: {
    type: Boolean,
    default: false
  },

  id: {
    type: Number,
    default: null
  }
},
  emits: ['clickContentManageDialogClose', 'clickContentManageDialogModify'],
  setup(__props, { emit }) {

const props = __props





const injector = useReflectiveInjector([ContentManageDialogService])
const contentManageDialogService = injector.get(ContentManageDialogService)

const formRef = ref(null)
const detailsData = ref<DetailData>({} as DetailData)
const isInit = ref(false)
const currentTagNames = ref([])
const previewImageUrls = computed(() => {
  return detailsData.value.page_images?.map(item => item.image_url) || []
})
const isDisabled = computed(() => {
  return ![
    OfficePlusStatus.PENDING_PRODUCTION,
    OfficePlusStatus.IN_PRODUCTION,
    OfficePlusStatus.PENDING_CONFIRMATION,
    OfficePlusStatus.SYNC_SUCCESS,
    OfficePlusStatus.SYNC_FAILED
  ].includes(detailsData.value.status)
})
const dialogHandle = reactive({
  visible: props.contentManageDialogVisible,
  loading: false,
  rules: {
    title: [
      { required: true, message: '请输入模板标题', trigger: 'blur' },
    ],
    keywords : [
      { required: true, message: '请输入关键词', trigger: 'blur' },
    ],
    price : [
      { required: true, message: '请输入价格', trigger: 'blur' },
    ],
    payment_type : [
      { required: true, message: '请选择付费类型', trigger: 'blur' },
    ],
  },
  close: () => {
    emit('clickContentManageDialogClose')
  },
})

contentManageDialogService.getDataById(props.id as number).then((res: DetailData) => {
  detailsData.value = res
}).finally(() => {
  isInit.value = true
})

const payTypesOptions = ref<PayTypes[]>([
  { label: PayTypeByLabelMap[PayTypeMap.pay], value: PayTypeMap.pay },
  { label: PayTypeByLabelMap[PayTypeMap.free], value: PayTypeMap.free }
])

function submit () {
  formRef.value?.validate((valid: boolean) => {
    if (valid) {
      dialogHandle.loading = true
      contentManageDialogService.modifyManageMat({ id: props.id as number, ...detailsData.value })
        .then(() => {
          dialogHandle.visible = false
          emit('clickContentManageDialogModify')
        }).finally(() => { dialogHandle.loading = false })
    } else {
      tipFunc()
      return false
    }
  })
}

function tipFunc(msg?: string, type?: 'warning' | 'success') {
  ElMessage[type || 'warning'](msg || '请填写完整信息')
}

function handleTagChange (data: any) {
  currentTagNames.value = data.tagsName
  detailsData.value.tag_ids = data.tagsId.join(',')
  detailsData.value.tag_names = data.tagsName.join(',')
  detailsData.value.sub_category_id = data.subCategoryId
  detailsData.value.l1_category_id = data.l1_category_id
  detailsData.value.l2_category_id = data.l2_category_id
  detailsData.value.l3_category_id = data.l3_category_id
}

function downloadTemplate () {
  contentManageDialogService.getDownloadUrl({ id: detailsData.value.id }).then((res: any) => {
    downloadByUrlAndName(res.url, `${detailsData.value.title}.zip`)
  })
}

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_el_space = _resolveComponent("el-space")!
  const _component_el_image = _resolveComponent("el-image")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createBlock(_component_el_dialog, {
    fullscreen: "",
    "close-on-click-modal": false,
    title: "内容管理",
    "before-close": _unref(dialogHandle).close,
    width: 1200
  }, {
    footer: _withCtx(() => [
      _createElementVNode("span", _hoisted_5, [
        _createVNode(_component_el_button, {
          loading: _unref(dialogHandle).loading,
          disabled: _unref(isDisabled),
          type: "primary",
          onClick: submit
        }, {
          default: _withCtx(() => [
            _hoisted_6
          ]),
          _: 1
        }, 8, ["loading", "disabled"])
      ])
    ]),
    default: _withCtx(() => [
      (isInit.value)
        ? (_openBlock(), _createBlock(_component_el_form, {
            key: 0,
            ref_key: "formRef",
            ref: formRef,
            class: "form_box",
            disabled: _unref(isDisabled),
            model: detailsData.value,
            rules: _unref(dialogHandle).rules,
            "label-width": "80px"
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                  _createVNode(_component_el_form_item, {
                    label: "模板名称",
                    prop: "title"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: detailsData.value.title,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((detailsData.value.title) = $event)),
                        placeholder: "请输入"
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_form_item, {
                    label: "关键词",
                    prop: "keywords"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: detailsData.value.keywords,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((detailsData.value.keywords) = $event)),
                        placeholder: "请输入"
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_form_item, {
                    label: "价格",
                    prop: "price"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: detailsData.value.price,
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((detailsData.value.price) = $event)),
                        placeholder: "请输入"
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_form_item, {
                    label: "付费类型",
                    prop: "payment_type"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_select, {
                        modelValue: detailsData.value.payment_type,
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((detailsData.value.payment_type) = $event)),
                        style: {"width":"100%"},
                        placeholder: "请选择"
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(payTypesOptions.value, (payType) => {
                            return (_openBlock(), _createBlock(_component_el_option, {
                              key: payType.value,
                              value: payType.value,
                              label: payType.label
                            }, null, 8, ["value", "label"]))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_form_item, {
                    label: "已选标签",
                    prop: "tag_ids"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_space, { wrap: "" }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(currentTagNames.value, (tag) => {
                            return (_openBlock(), _createBlock(_component_el_tag, {
                              size: "small",
                              key: tag
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(tag), 1)
                              ]),
                              _: 2
                            }, 1024))
                          }), 128))
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_form_item, {
                    label: "缩略图",
                    prop: "cover_image_url"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_image, {
                        class: "c-image",
                        src: detailsData.value.cover_image_url,
                        "preview-src-list": [detailsData.value.cover_image_url],
                        fit: "cover"
                      }, null, 8, ["src", "preview-src-list"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_form_item, {
                    label: "预览图",
                    prop: "cover_image_url"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_space, { wrap: "" }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(detailsData.value.page_images, (item, index) => {
                            return (_openBlock(), _createBlock(_component_el_image, {
                              key: index,
                              class: "c-image",
                              src: item.image_url,
                              "preview-src-list": _unref(previewImageUrls),
                              "initial-index": index,
                              fit: "cover"
                            }, null, 8, ["src", "preview-src-list", "initial-index"]))
                          }), 128))
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_form_item, {
                    label: "模板预览",
                    prop: "cover_image_url"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_button, {
                        type: "primary",
                        onClick: downloadTemplate
                      }, {
                        default: _withCtx(() => [
                          _hoisted_3
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("div", _hoisted_4, [
                  _createVNode(CTagSelect, {
                    categoryId: detailsData.value.l1_category_id,
                    subCategoryId: detailsData.value.l2_category_id,
                    tagIds: detailsData.value.tag_ids,
                    thirdCategoryId: detailsData.value.l3_category_id,
                    onChange: handleTagChange
                  }, null, 8, ["categoryId", "subCategoryId", "tagIds", "thirdCategoryId"])
                ])
              ])
            ]),
            _: 1
          }, 8, ["disabled", "model", "rules"]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["before-close"]))
}
}

})